import React from 'react';
import type { IReactTemplateProps, ReactTemplateRenderFunction } from './types';

export function ReactTemplate(props: IReactTemplateProps): JSX.Element {
  const {
    interpolate = /{{\s*([^}]+?)\s*}}/g,
    model,
    template,
  } = props;

  function parseTemplate(templateStr: string): React.ReactNode[] {
    try {
      let current = 0;
      const fragments: React.ReactNode[] = [];
      while (true) {
        const match = interpolate!.exec(templateStr);

        if (match === null) break;

        const {
          0: nameWithBraces,
          1: name,
          index,
        } = match;

        const trimmedName = name.trim();

        const plainString = templateStr.substring(current, index);
        current = index + nameWithBraces.length;

        if (plainString) {
          fragments.push(plainString);
        }

        if (typeof model[trimmedName] === 'function') {
          const matchedPair = interpolate!.exec(templateStr);
          if (matchedPair === null) {
            throw new SyntaxError(`Expected matching pair in form of {{/${trimmedName}}} but found none`);
          }
          const pairedNameWithBraces = matchedPair[0];
          const pairedName = matchedPair[1].trim();
          const pairedIndex = matchedPair.index;
          if (pairedName[0] !== '/' || pairedName.substring(1).trim() !== trimmedName) {
            throw new SyntaxError(`Expected matching pair in form of {{/${trimmedName}}} but found different match`);
          }
          const funcParamText = templateStr.substring(current, pairedIndex);

          fragments.push((model[trimmedName] as ReactTemplateRenderFunction)(funcParamText));
          current = pairedIndex + pairedNameWithBraces.length;
        } else {
          fragments.push(model[trimmedName]);
        }
      }

      const tail = templateStr.substring(current);
      if (tail) fragments.push(tail);

      return fragments;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  const fragmentsArray = parseTemplate(template);

  if (!fragmentsArray.length) {
    return (template || '') as unknown as JSX.Element;
  }

  return (
    <>
      {fragmentsArray.map((frag, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={String(index)}>
          {frag}
        </React.Fragment>
      ))}
    </>
  );
}
